import axios from 'axios';

export const namespaced = true;

export const state = {
  locationOptions: [],
  locationSelected: null,
  appointmentsCalendarPage: {
    calendarEvents: [],
    currentCalendarRange: null,
    showTimeSlotDialog: false,
    calendarLoader: false,
    clickedDate: null
  },
  appointmentsSelectedDayPage: {
    showAppointmentBookingDialog: false,
    selectedAppoinmentDateTime: null,
    appointments: [],
    loadingAppointments: false,
    selectedDate: null,
    timeSlots: [],
    loadingSlots: false,
    selectedSlot: null,
    confirmDeleteDialog: false,
    rescheduleAppointmentDialog: false,
    currentSelectedSlotId: null
  }
};

export const actions = {
  async clearTimeSlot({ rootState, dispatch }, payload) {
    return await axios
      .delete(`${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/${payload.minDate}/${payload.maxDate}?location=${payload.locationId}`)
      .then(res => {
        if (res.status == 200 || res.status == 204) {
          return true;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error deleting slots', { root: true });
        return false;
      });
  },

  async getCalenderDayManualAppointments({ rootState, dispatch, commit }, payload) {
    let _url = `${rootState.baseUrlApi}/labhoh-restful-api/hoh/localtestform/${payload.minDate}/${payload.maxDate}`;
    if (payload.locationId != null) _url += '?location=' + payload.locationId;

    commit('SET_APPOINTMENTS', []);
    commit('SET_APPOINTMENTS_LOADER', true);
    return await axios
      .get(_url)
      .then(res => {
        commit('SET_APPOINTMENTS_LOADER', false);
        if (res.status == 200) {
          if (res.data.length) commit('SET_APPOINTMENTS', res.data);
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_APPOINTMENTS_LOADER', false);
        dispatch('showError', 'Error loading calendar data for this date', { root: true });
        return false;
      });
  },
  async getCalenderDaySlots({ rootState, dispatch, commit }, payload) {
    if (payload.showLoader != false) {
      commit('SET_TIME_SLOTS', []);
      commit('SET_TIME_SLOTS_LOADER', true);
    }
    let _url = `${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/${payload.minDate}/${payload.maxDate}`;
    if (payload.locationId != null) _url += '?location=' + payload.locationId;

    return await axios
      .get(_url)
      .then(res => {
        if (payload.showLoader != false) commit('SET_TIME_SLOTS_LOADER', false);
        if (res.status == 200) {
          if (res.data.length) commit('SET_TIME_SLOTS', res.data);
        }
      })
      .catch(error => {
        console.log(error);
        if (payload.showLoader != false) commit('SET_TIME_SLOTS_LOADER', false);
        dispatch('showError', 'Error loading calendar data for this date', { root: true });
        return false;
      });
  },
  async getCalenderDaySlotsForRescheduling({ rootState, dispatch }, payload) {
    let _url = `${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/${payload.minDate}/${payload.maxDate}`;
    if (payload.locationId != null) _url += '?location=' + payload.locationId;

    return await axios
      .get(_url)
      .then(res => {
        if (res.status == 200 || res.status == 204) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error loading calendar data for this date', { root: true });
        return false;
      });
  },
  //Calendar page
  async getCalendarEntries({ rootState, dispatch }, payload) {
    // const queryParams = {
    //   location: payload.locationId,
    // };

    let _url = `${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/group/${payload.minDate}/${payload.maxDate}`;
    if (payload.locationId != null) _url += `?location=${payload.locationId}`;

    return await axios
      //.get(_url, queryParams)
      .get(_url)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error loading calendar data', { root: true });
      });
  },
  async rescheduleAppoiment({ rootState, dispatch }, payload) {
    return await axios
      .put(`${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/swap`, payload)
      .then(res => {
        if (res.status == 204 || res.status == 200) return true;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error rescheduling appointment', { root: true });
        return false;
      });
  },
  async submitAppointment({ rootState, dispatch }, payload) {
    return await axios
      .post(`${rootState.baseUrlApi}/labhoh-restful-api/hoh/localtestform`, payload)
      .then(res => {
        if (res.status == 204 || res.status == 200) return true;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error submitting appointment data', { root: true });
        return false;
      });
  },

  async submitAppointmentSlotsForm({ rootState, dispatch }, payload) {
    return await axios
      .post(`${rootState.baseUrlApi}/labhoh-restful-api/agendaslot/multi`, payload)
      .then(res => {
        if (res.status == 204 || res.status == 200) return true;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error submitting appointment data', { root: true });
        return false;
      });
  },

  async getLocationOptions({ rootState, dispatch, commit }) {
    return await axios
      .get(`${rootState.baseUrlApi}/labhoh-restful-api/testcenter`)
      .then(res => {
        if (res.status == 200) {
          commit('SET_LOCATIONS_OPTIONS', res.data);
          //return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error loading doctor options', { root: true });
      });
  }
};

export const mutations = {
  // selected day ------------------------------------------------------------------------
  SET_SELECTED_DATE_TIME_APPOINTMENT(state, payload) {
    state.appointmentsSelectedDayPage.selectedAppoinmentDateTime = payload;
  },

  SET_APPOINTMENT_BOOKING_DIALOG(state, action) {
    state.appointmentsSelectedDayPage.showAppointmentBookingDialog = action;
  },

  SET_APPOINTMENTS(state, payload) {
    state.appointmentsSelectedDayPage.appointments = payload;
  },

  SET_APPOINTMENTS_LOADER(state, action) {
    state.appointmentsSelectedDayPage.loadingAppointments = action;
  },

  SET_CLICKED_DATE(state, payload) {
    state.appointmentsCalendarPage.clickedDate = payload;
  },

  SET_CURRENT_CALENDAR_EVENTS(state, payload) {
    state.appointmentsCalendarPage.calendarEvents = payload;
  },

  SET_CURRENT_CALENDAR_EVENT_RANGE(state, payload) {
    state.appointmentsCalendarPage.currentCalendarRange = payload;
  },

  SET_CURRENT_CALENDAR_LOADER(state, action) {
    state.appointmentsCalendarPage.calendarLoader = action;
  },

  SET_SELECTED_DATE(state, payload) {
    state.appointmentsSelectedDayPage.selectedDate = payload;
  },

  SET_TIME_SLOTS(state, payload) {
    let payloadWithLoader = payload.map(item => {
      return { ...item, loader: false };
    });
    state.appointmentsSelectedDayPage.timeSlots = payloadWithLoader;
  },

  SET_TIME_SLOT_DIALOG(state, action) {
    state.appointmentsCalendarPage.showTimeSlotDialog = action;
  },

  SET_TIME_SLOTS_LOADER(state, action) {
    state.appointmentsSelectedDayPage.loadingSlots = action;
  },

  SET_SELECTED_SLOT(state, payload) {
    state.appointmentsSelectedDayPage.selectedSlot = payload;
  },

  SET_SINLGE_SLOT_LOADER(state, payload) {
    state.appointmentsSelectedDayPage.timeSlots.forEach(slot => {
      if (slot.id == payload.id) slot.loader = payload.action;
    });
  },

  SET_CONFIRM_DELETE_SLOTS_DIALOG(state, action) {
    state.appointmentsSelectedDayPage.confirmDeleteDialog = action;
  },

  SET_CURRENT_SELECTED_SLOT_ID(state, payload) {
    state.appointmentsSelectedDayPage.currentSelectedSlotId = payload;
  },

  SET_RESCHEDULE_APPOINTMENT_DIALOG(state, action) {
    state.appointmentsSelectedDayPage.rescheduleAppointmentDialog = action;
  },

  SET_LOCATIONS_OPTIONS(state, payload) {
    let locations = payload.map(location => {
      return {
        location: location.name,
        id: location.id,
        address: location.address
      };
    });
    state.locationOptions = locations;
  },

  SET_SELECTED_LOCATION(state, payload) {
    state.locationSelected = payload;
  }
};

export const getters = {
  currentCalendarRange: state => {
    return state.appointmentsCalendarPage.currentCalendarRange;
  },
  showAppointmentBookingDialog: state => {
    return state.appointmentsSelectedDayPage.showAppointmentBookingDialog;
  }
};
